import { Model } from 'modula';

class Test extends Model {
  static defaultProps = {
    name: 'test'
  };
}

export default Test;
